<div class="kmf">
  <div class="kmf-header">
    <span class="kmf-subtitle">Conditions</span>
    <button
      type="button"
      class="kmf-add-btn"
      (click)="addCondition()"
      aria-label="Add condition"
      title="Add another filter condition"
    >
      <ion-icon name="add-outline"></ion-icon>
      <span>Add Rule</span>
    </button>
  </div>

  <div class="kmf-logic-row" *ngIf="conditions.length > 1">
    <span class="kmf-logic-label">Match</span>
    <div class="kmf-logic-toggles">
      <button
        type="button"
        class="kmf-logic-pill"
        [class.kmf-logic-pill--active]="logic === 'and'"
        (click)="logic = 'and'"
      >
        AND (All)
      </button>
      <button
        type="button"
        class="kmf-logic-pill"
        [class.kmf-logic-pill--active]="logic === 'or'"
        (click)="logic = 'or'"
      >
        OR (Any)
      </button>
    </div>
  </div>

  <div class="kmf-conditions-list">
    @for (c of conditions; track c.id; let i = $index) {
      <div class="kmf-condition-row">
        <div class="kmf-condition-fields">
          <div class="kmf-field kmf-field--operator">
            <label class="kmf-label">Operator</label>
            <select class="kmf-select" [(ngModel)]="c.operator">
              @for (op of operatorOptionsList; track op.value) {
                <option [value]="op.value">{{ op.text }}</option>
              }
            </select>
          </div>

          <div class="kmf-field kmf-field--value" *ngIf="needsValue(c.operator); else noValue">
            <label class="kmf-label">Value</label>
            <ng-container [ngSwitch]="inputKind()">
              <input
                *ngSwitchCase="'number'"
                class="kmf-input"
                type="number"
                [(ngModel)]="c.value"
                placeholder="Number..."
                (keydown.enter)="apply()"
              />

              <select
                *ngSwitchCase="'boolean'"
                class="kmf-select"
                [(ngModel)]="c.value"
              >
                <option value="true">True</option>
                <option value="false">False</option>
              </select>

              <input
                *ngSwitchCase="'datetime'"
                class="kmf-input"
                type="datetime-local"
                [(ngModel)]="c.value"
                (keydown.enter)="apply()"
              />

              <input
                *ngSwitchDefault
                class="kmf-input"
                type="text"
                [(ngModel)]="c.value"
                placeholder="Value..."
                (keydown.enter)="apply()"
              />
            </ng-container>
          </div>

          <ng-template #noValue>
            <div class="kmf-no-value">
              <span class="kmf-no-value-label">No value required</span>
            </div>
          </ng-template>
        </div>

        <button
          type="button"
          class="kmf-remove-btn"
          (click)="removeCondition(i)"
          [disabled]="conditions.length <= 1"
          aria-label="Remove condition"
          title="Remove this condition"
        >
          <ion-icon name="close-outline"></ion-icon>
        </button>
      </div>
    }
  </div>

  <div class="kmf-actions">
    <button
      type="button"
      class="kmf-btn kmf-btn--primary"
      (click)="apply()"
      [disabled]="!canApply()"
    >
      <ion-icon name="funnel-outline"></ion-icon>
      <span>Apply Filter</span>
    </button>
    <button
      type="button"
      class="kmf-btn kmf-btn--secondary"
      (click)="clearColumn()"
    >
      <ion-icon name="refresh-outline"></ion-icon>
      <span>Clear</span>
    </button>
  </div>
</div>

